// extracted by mini-css-extract-plugin
export var divider = "_el-7";
export var itemsToggle = "_el-8";
export var mergeModal = "_el-1";
export var optionCard = "_el-4";
export var radioGroup = "_el-6";
export var radioOption = "_el-0";
export var selected = "_el-5";
export var shipmentOptions = "_el-2";
export var tableOptions = "_el-3";